import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, withApollo } from 'react-apollo'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  NavLink
} from 'react-router-dom'
import { Dropdown, Layout, Menu, Icon, Avatar, Spin } from 'antd'
import moment from 'moment'
import HeroNews from './HeroNews'

import Login from './Login'
import Dashboard from './Dashboard'
import Documents from './Documents'
import Users from './Users'
import Logs from './Logs'
import HeroConfig from './HeroConfig'
import Heroes from './Heroes'
import LogContract from './LogContract'
import Brands from './Brand'
import Category from './Category'
import CategoryEquipment from './CategoryEquipment'
import Equipment from './Equipment'
import Seller from './Seller'
import Quotation from './Quotation'
import Material from './Material'
import Account from './Account'
import Step from './Step'
import AppUsers from './AppUsers'
import LOMAUsers from './LOMAUsers'
import PackageList from './PackageList'
import SubsctiptionPackage from './SubscriptionPackage'
import PlanList from './PlanList'
import SubsctiptionPlan from './SubscriptionPlan'
import CustomerTag from './CustomerTag'
import ApiPartner from './ApiPartner'
import ApiPartnerDetail from './ApiPartner/Detail'
import TierFeature from './TierFeature'
import Banks from './Banks'
import Preset from './Preset'
import ProductFeature from './ProductFeature'
import BarcodeProduct from './BarcodeProduct'
import BarcodeProductCategory from './BarcodeProductCategory'
import RecycleBarcodeProduct from './RecycleBarcodeProduct'
import News from './News'
import Reward from './Reward'
import RewardCondition from './RewardCondition'
import RedeemTransaction from './RedeemTransaction'
import PointTransaction from './PointTransaction'
import CouponReport from './CouponReport'
import PointGrant from './PointGrant'
import PointGainType from './PointGainType'
import UserPoint from './UserPoint'
import Banners from './Banners'
import Bin from './Bin'
import Delay from './Delay'
import ForceUpdate from './ForceUpdate'
import CoinPackage from './CoinPackage'
import CoinTransaction from './CoinTransaction'
import Remark from './Remark'
import CoinUsed from './CoinUsed'
import AppConfig from './AppConfig'
import ReportProblem from './ReportProblem'
import UserAnnouncement from './UserAnnouncement'
import HeroPromote from './HeroPromote'
import Notification from './Notification'
import NotificationUser from './NotificationUser'
import HeroPO from './HeroPO'
import HeroPOD from './HeroPOD'
import Version from '../components/Version'
import { styles, MenuWrapper, Logo, Centered } from './styles'
import MaterialLink from './MaterialLink'
import MaterialAlias from './MaterialAlias'
import MaterialCustom from './MaterialCustom'
import Reports from './Reports'
import PDPA from './PDPA'
import Transaction from './Transaction'
import BrandActivityTransaction from './BrandActivityTransaction'
import PriceDashboard from './PriceDashboard'
import PriceManagement from './PriceManagement'
import PriceGroups from './PriceGroups'
import PriceSchedules from './PriceSchedules'

const { Header, Sider, Content } = Layout
const logo = require('../assets/images/logo-inverse.png')
const g2gLogo = require('../assets/images/g2g.png')

export class App extends Component {
  constructor() {
    super()

    this.state = {
      collapsed: false,
      visible: false,
      confirmLoading: false
    }

    this.toggle = this.toggle.bind(this)
    this.logout = this.logout.bind(this)
    this.menu = this.menu.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed
    }))
  }

  visible = () => {
    this.setState({
      visible: true
    })
  }

  handleOk = () => {
    this.setState({
      confirmLoading: true
    })
    setTimeout(() => {
      this.setState({
        visible: false,
        confirmLoading: false
      })
      this.logout()
    }, 1000)
  }

  handleCancel = () => {
    this.setState({
      visible: false
    })
  }

  logout() {
    const { client } = this.props
    localStorage.removeItem('user-token')
    localStorage.removeItem('data')
    localStorage.removeItem('expire')
    window.location.href = '/'
    client.resetStore()
  }

  menu() {
    return (
      <Menu>
        <Menu.Item onClick={() => this.visible()}>
          <Icon type="user" style={{ marginRight: '8px' }} />
          Account
        </Menu.Item>
        <Menu.Item onClick={() => this.logout()}>
          <Icon type="poweroff" />
          Logout
        </Menu.Item>
      </Menu>
    )
  }

  render() {
    const { collapsed, visible, confirmLoading } = this.state
    const data = JSON.parse(localStorage.getItem('data'))
    const expire = JSON.parse(localStorage.getItem('expire'))

    if (moment(expire).isBefore(moment())) {
      setTimeout(() => {
        this.logout()
      }, 1000)
    }

    return (
      <Router>
        {data && data.id ? (
          <Layout style={{ minHeight: '100vh' }}>
            <Sider trigger={null} collapsible collapsed={collapsed} width={250}>
              <Logo style={{ backgroundColor: '#001529' }}>
                {collapsed ? (
                  <img src={g2gLogo} width="20" alt="Full width logo" />
                ) : (
                  <img src={logo} width="120" alt="Logo" />
                )}
              </Logo>
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['1']}
                style={{
                  overflowY: 'auto',
                  maxHeight: 'calc(100vh - 64px)'
                }}>
                <Menu.Item key="1">
                  <NavLink to="/">
                    <Icon type="home" />
                    <span>Dashboard</span>
                  </NavLink>
                </Menu.Item>
                <Menu.SubMenu
                  key="Transaction"
                  title={
                    <span>
                      <Icon type="bar-chart" />
                      <span>Transaction</span>
                    </span>
                  }>
                  <Menu.Item key="transaction">
                    <NavLink to="/transaction">
                      <span>All Transaction</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="brand-activity-transaction">
                    <NavLink to="/brand-activity-transaction">
                      <span>Brand Activity</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="user-announcement">
                    <NavLink to="/user-announcement">
                      <span>User Announcement</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="heroPromote">
                    <NavLink to="/heroPromote">
                      <span>Hero Promote</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="brands"
                  title={
                    <span>
                      <Icon type="tag" />
                      <span>Brands</span>
                    </span>
                  }>
                  <Menu.Item key="brands">
                    <NavLink to="/brands">
                      <span>Brands</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="product-feature">
                    <NavLink to="/product-feature">
                      <span>Product Feature</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="green2getApp"
                  title={
                    <span>
                      <Icon type="user" />
                      <span>Green2Get app</span>
                    </span>
                  }>
                  <Menu.Item key="app-users">
                    <NavLink to="/app-users">
                      <span>Users</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu key="reward" title="Reward">
                    <Menu.Item key="reward">
                      <NavLink to="/reward">
                        <span>Reward</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="RewardCondition">
                      <NavLink to="/reward-condition">
                        <span>Reward Condition</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="RedeemTransaction">
                      <NavLink to="/redeem-transaction">
                        <span>Redeem Transaction</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="CouponReport">
                      <NavLink to="/coupon-report">
                        <span>Coupon Report</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="PointGrant">
                      <NavLink to="/point-grant">
                        <span>Grant Point</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="PointTransaction">
                      <NavLink to="/point-transaction">
                        <span>Point Transaction</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="PointGainType">
                      <NavLink to="/point-gain-type">
                        <span>Point Gain Type</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="userPoint">
                      <NavLink to="/user-point">
                        <span>User Point</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.Item key="report-problem">
                    <NavLink to="/report-problem">
                      <span>Report Problem</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="hero"
                  title={
                    <span>
                      <Icon type="team" />
                      <span>Heroes app</span>
                    </span>
                  }>
                  <Menu.Item key="heroes">
                    <NavLink to="/heroes">
                      <span>Heroes</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="log-contract">
                    <NavLink to="/log-contract">
                      <span>Log Contract</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="documents">
                    <NavLink to="/documents">
                      <span>Documents</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.SubMenu key="equipment" title="Equipment">
                    <Menu.Item key="category-equipment">
                      <NavLink to="/category-equipment">
                        <span>Equipment Category</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="equipment">
                      <NavLink to="/equipment">
                        <span>Equipment</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="seller">
                      <NavLink to="/seller">
                        <span>Seller</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="quotation">
                      <NavLink to="/quotation">
                        <span>Quotation</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu key="coin" title="Coin">
                    <Menu.Item key="coin-package">
                      <NavLink to="/coin-package">
                        <span>Coin Package</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="coin-transaction">
                      <NavLink to="/coin-transaction">
                        <span>Coin Transaction</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="coin-used">
                      <NavLink to="/coin-used">
                        <span>Coin Used</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.SubMenu key="groupSelling" title="Group Selling">
                    <Menu.Item key="po">
                      <NavLink to="/PO">
                        <span>รายการรับซื้อ (PO)</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="pod">
                      <NavLink to="/POD">
                        <span>รายการส่ง (POD)</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                  <Menu.Item key="app-config">
                    <NavLink to="/app-config">
                      <span>App Config</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="LOMAApp"
                  title={
                    <span>
                      <Icon type="user" />
                      <span>LOMA app</span>
                    </span>
                  }>
                  <Menu.Item key="loma-users">
                    <NavLink to="/loma-users">
                      <span>User List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="package-list">
                    <NavLink to="/package-list">
                      <span>Package List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="subscription-package">
                    <NavLink to="/subscription-package">
                      <span>Subscription Package</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="plan-list">
                    <NavLink to="/plan-list">
                      <span>Plan List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="subscription-plan">
                    <NavLink to="/subscription-plan">
                      <span>Subscription Plan</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="tier-feature">
                    <NavLink to="/tier-feature">
                      <span>Tier Feature</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="customer-tag">
                    <NavLink to="/customer-tag">
                      <span>Customer Tag</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="api-partner">
                    <NavLink to="/api-partner">
                      <span>API Partner</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="products"
                  title={
                    <span>
                      <Icon type="rest" />
                      <span>Material</span>
                    </span>
                  }>
                  <Menu.Item key="material-category">
                    <NavLink to="/category">
                      <span>Material Category</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="material">
                    <NavLink to="/material">
                      <span>Material List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="material-link">
                    <NavLink to="/material-link">
                      <span>Material Link</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="material-alias">
                    <NavLink to="/material-alias">
                      <span>Material Alias</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="material-custom">
                    <NavLink to="/material-custom">
                      <span>Shop Materials</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="barcode-product"
                  title={
                    <span>
                      <Icon type="barcode" />
                      <span>Barcode Product</span>
                    </span>
                  }>
                  <Menu.Item key="barcode-product-category">
                    <NavLink to="/barcodeProductCategory">
                      <span>Barcode Product Category List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="barcode-product-list">
                    <NavLink to="/barcodeProduct">
                      <span>Barcode Product List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="recycle-barcode-product-list">
                    <NavLink to="/recycleBarcodeProduct">
                      <span>Recycle Barcode Product List</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="step-list">
                    <NavLink to="/step">
                      <span>Step</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="preset-list">
                    <NavLink to="/preset">
                      <span>Preset</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="news"
                  title={
                    <span>
                      <Icon type="sound" />
                      <span>News</span>
                    </span>
                  }>
                  <Menu.Item key="news">
                    <NavLink to="/news">
                      <span>Users News</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="heroNews">
                    <NavLink to="/hero-news">
                      <span>Hero News</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="banners">
                    <NavLink to="/banners">
                      <span>Popup Banners</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="notification">
                    <NavLink to="/notification">
                      <span>Notification</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="notificationUser">
                    <NavLink to="/notificationUser">
                      <span>Notification User</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="CircularBin"
                  title={
                    <span>
                      <Icon type="delete" />
                      <span>Circular Bin</span>
                    </span>
                  }>
                  <Menu.Item key="bin">
                    <NavLink to="/bin">
                      <span>Device</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="circularbin">
                    <NavLink to="/reports">
                      <span>Bin Transaction</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.SubMenu
                  key="priceBot"
                  title={
                    <span>
                      <Icon type="line-chart" />
                      <span>Price Bot</span>
                    </span>
                  }>
                  <Menu.Item key="price-dashboard">
                    <NavLink to="/prices/dashboard">
                      <span>Dashboard</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="price-manage">
                    <NavLink to="/prices/manage">
                      <span>จัดการราคา</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="price-groups">
                    <NavLink to="/prices/groups">
                      <span>กลุ่มลูกค้า</span>
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="price-schedules">
                    <NavLink to="/prices/schedules">
                      <span>Log การดึงราคา</span>
                    </NavLink>
                  </Menu.Item>
                </Menu.SubMenu>
                {data.role === 'ADMIN' && (
                  <Menu.SubMenu
                    key="settings"
                    title={
                      <span>
                        <Icon type="setting" />
                        <span>Settings</span>
                      </span>
                    }>
                    <Menu.Item key="force-update">
                      <NavLink to="/force-update">
                        <span>Force Update</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="delay">
                      <NavLink to="/delay">
                        <span>Transaction Delay</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="remark">
                      <NavLink to="/remark">
                        <span>Remark</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="pd-pa">
                      <NavLink to="/pd-pa">
                        <span>PDPA</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="users">
                      <NavLink to="/users">
                        <span>Users</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="banks">
                      <NavLink to="/banks">
                        <span>Banks</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="heroConfig">
                      <NavLink to="/heroConfig">
                        <span>Heroes</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="logs">
                      <NavLink to="/logs">
                        <span>Logs</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu.SubMenu>
                )}
                <Version color="grey" />
              </Menu>
            </Sider>
            <Layout>
              {process.env.REACT_APP_USE_MOCK === '1' && (
                <div
                  style={{
                    background: '#fa541c',
                    color: '#fff',
                    textAlign: 'center',
                    fontWeight: 600,
                    padding: '4px 0',
                    letterSpacing: 1
                  }}>
                  MOCK DATA — ข้อมูลบางส่วนไม่ได้มาจาก API จริง
                </div>
              )}
              <Header style={{ background: '#fff', padding: 0 }}>
                <Icon
                  style={{ padding: '0 24px' }}
                  className="trigger"
                  type={collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />
                <MenuWrapper>
                  <Dropdown
                    overlay={this.menu}
                    placement="topRight"
                    trigger={['click']}>
                    <a href="/">
                      <React.Fragment>
                        {data.name}
                        <Avatar
                          src={data.avatar}
                          style={{ marginLeft: '8px' }}
                        />
                      </React.Fragment>
                    </a>
                  </Dropdown>
                </MenuWrapper>
              </Header>
              <Content style={styles.content}>
                <Switch>
                  <Route exact path="/" component={Dashboard} />
                  <Route exact path="/users" component={Users} />
                  <Route exact path="/logs" component={Logs} />
                  <Route exact path="/heroConfig" component={HeroConfig} />
                  <Route exact path="/heroes" component={Heroes} />
                  <Route exact path="/app-users" component={AppUsers} />
                  <Route exact path="/loma-users" component={LOMAUsers} />
                  <Route exact path="/package-list" component={PackageList} />
                  <Route
                    exact
                    path="/subscription-package"
                    component={SubsctiptionPackage}
                  />
                  <Route exact path="/plan-list" component={PlanList} />
                  <Route
                    exact
                    path="/subscription-plan"
                    component={SubsctiptionPlan}
                  />
                  <Route exact path="/tier-feature" component={TierFeature} />
                  <Route exact path="/customer-tag" component={CustomerTag} />
                  <Route exact path="/api-partner" component={ApiPartner} />
                  <Route
                    exact
                    path="/api-partner/:id"
                    component={ApiPartnerDetail}
                  />
                  <Route exact path="/log-contract" component={LogContract} />
                  <Route exact path="/documents" component={Documents} />
                  <Route
                    exact
                    path="/coin-transaction"
                    component={CoinTransaction}
                  />
                  <Route exact path="/remark" component={Remark} />
                  <Route exact path="/pd-pa" component={PDPA} />
                  <Route exact path="/coin-used" component={CoinUsed} />
                  <Route exact path="/brands" component={Brands} />
                  <Route exact path="/app-config" component={AppConfig} />
                  <Route
                    exact
                    path="/user-announcement"
                    component={UserAnnouncement}
                  />
                  <Route exact path="/heroPromote" component={HeroPromote} />
                  <Route exact path="/PO" component={HeroPO} />
                  <Route exact path="/POD" component={HeroPOD} />
                  <Route exact path="/notification" component={Notification} />
                  <Route
                    exact
                    path="/notificationUser"
                    component={NotificationUser}
                  />
                  <Route exact path="/category" component={Category} />
                  <Route exact path="/material" component={Material} />
                  <Route exact path="/material-link" component={MaterialLink} />
                  <Route
                    exact
                    path="/material-alias"
                    component={MaterialAlias}
                  />
                  <Route
                    exact
                    path="/material-custom"
                    component={MaterialCustom}
                  />

                  <Route
                    exact
                    path="/category-equipment"
                    component={CategoryEquipment}
                  />
                  <Route exact path="/equipment" component={Equipment} />
                  <Route exact path="/seller" component={Seller} />
                  <Route exact path="/quotation" component={Quotation} />

                  <Route
                    exact
                    path="/product-feature"
                    component={ProductFeature}
                  />
                  <Route exact path="/step" component={Step} />
                  <Route exact path="/preset" component={Preset} />
                  <Route exact path="/reports" component={Reports} />
                  <Route exact path="/transaction" component={Transaction} />
                  <Route
                    exact
                    path="/brand-activity-transaction"
                    component={BrandActivityTransaction}
                  />
                  <Route exact path="/delay" component={Delay} />
                  <Route exact path="/force-update" component={ForceUpdate} />
                  <Route exact path="/coin-package" component={CoinPackage} />
                  <Route
                    exact
                    path="/report-problem"
                    component={ReportProblem}
                  />
                  {/* <Route
                    exact
                    path="/PresetCategory"
                    component={PresetCategory}
                  /> */}
                  <Route
                    exact
                    path="/barcodeProduct"
                    component={BarcodeProduct}
                  />
                  <Route
                    exact
                    path="/barcodeProductCategory"
                    component={BarcodeProductCategory}
                  />
                  <Route
                    exact
                    path="/recycleBarcodeProduct"
                    component={RecycleBarcodeProduct}
                  />
                  <Route exact path="/news" component={News} />
                  <Route exact path="/hero-news" component={HeroNews} />
                  <Route exact path="/banners" component={Banners} />
                  <Route exact path="/banks" component={Banks} />
                  <Route exact path="/reward" component={Reward} />
                  <Route
                    exact
                    path="/reward-condition"
                    component={RewardCondition}
                  />
                  <Route
                    exact
                    path="/redeem-transaction"
                    component={RedeemTransaction}
                  />
                  <Route
                    exact
                    path="/coupon-report"
                    component={CouponReport}
                  />
                  <Route exact path="/point-grant" component={PointGrant} />
                  <Route
                    exact
                    path="/point-transaction"
                    component={PointTransaction}
                  />
                  <Route
                    exact
                    path="/point-gain-type"
                    component={PointGainType}
                  />
                  <Route exact path="/user-point" component={UserPoint} />
                  <Route exact path="/bin" component={Bin} />
                  <Route
                    exact
                    path="/prices/dashboard"
                    component={PriceDashboard}
                  />
                  <Route
                    exact
                    path="/prices/manage"
                    component={PriceManagement}
                  />
                  <Route
                    exact
                    path="/prices/groups"
                    component={PriceGroups}
                  />
                  <Route
                    exact
                    path="/prices/schedules"
                    component={PriceSchedules}
                  />

                  <Redirect from="*" to="/" />
                </Switch>
              </Content>
            </Layout>
            <Account
              visible={visible}
              onOk={this.handleOk}
              confirmLoading={confirmLoading}
              onCancel={this.handleCancel}
              formData={data}
            />
          </Layout>
        ) : (
          <Switch>
            <Route exact path="/" component={Login} />
            <Redirect from="*" to="/" />
          </Switch>
        )}
      </Router>
    )
  }
}

App.propTypes = {
  data: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired
}

export default compose(withApollo)(App)
